import { render, staticRenderFns } from "./AdminOrder.vue?vue&type=template&id=c8f6b0ea&"
import script from "./AdminOrder.vue?vue&type=script&lang=js&"
export * from "./AdminOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports